angular.module("avant.customer_applications.directives").directive "mobileCompactHide", [
  '$window'
  '$interval'
  '$rootScope'
  'HelperService'
  ($window, $interval, $rootScope, HelperService) ->
    restrict: 'A'
    link: (scope, element, attrs) ->
      return unless HelperService.isTouchDevice

      height = element.height()
      last_position = 0

      checkVisibility = (position) ->
        position > height && element.hide() || element.show()
        last_position = position

      # Hide on input focus
      scope.$on "app:field:focus", (event, data) -> 
        element.hide()

      # Show on input blur unless hideOnScroll and at top of page
      scope.$on "app:field:blur", (event, data) -> 
        if attrs.hideOnScroll?
          checkVisibility last_position
        else
          element.show()

      # Hide unless position is top of page
      if attrs.hideOnScroll?
        $rootScope.$on 'app:scroll', (event, position) ->
          checkVisibility position
      else
        # FIXME: Should probably pass this string into the directive for modularity
        $rootScope.$on "section_visibility:personal:main", (event, data) -> element.hide()
]
